import queryString from 'query-string';
import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const action = createActions({
  ADMIN: {
    GET_USER_DATA: (filter) => ({ filter }),
    API: {
      GET_USER_DATA: apiResourceActionCreator('userStat')
    }
  }
})

export const apiAction = (authToken, filter) => commonApiActions.authenticated.get(`${API_ENDPOINT}/getUserData?${queryString.stringify(filter)}`, authToken, action.admin.api.getUserData)

function* getUserData(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload.filter));
}

const configuration = {
  name: 'getUserData',
  action: action,
  sagas: getUserData,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetchingReport: true
    }),
    success: (state, action) => ({
      ...state,
      isFetchingReport: false,
      userStat: state.userStat ? {
        ...action.payload.userStat,
        result: state.userStat.result.concat(action.payload.userStat.result)
      } : action.payload.userStat
    }),
    failed: (state, action) => ({
      ...state,
      isFetchingReport: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/getUserData.js